import { render, staticRenderFns } from "./ShippingChargeAreaFee.vue?vue&type=template&id=51ee6d02&"
import script from "./ShippingChargeAreaFee.vue?vue&type=script&lang=ts&"
export * from "./ShippingChargeAreaFee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports